import React, { useState, useEffect } from 'react';
import apiService from './api';
import { Box, Typography } from '@mui/material';
import '../components/Surveys/SurveyPopup.css';
import PropTypes from 'prop-types';

const downarrow= apiService.getBlobAssetUrl('Dropdown_3.svg');
const arrowicon= apiService.getBlobAssetUrl('ForwardArrow.svg');

const ViewSurveyTemplate = ({ surveyId }) => {
  const [surveyData, setSurveyData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedSections, setExpandedSections] = useState({});
  const [ questionTypes,setQuestionTypes] = useState([]);
  const [userResponses, setUserResponses] = useState({});

  const formatQuestion = (question, fetchedQuestionTypes) => {
  const questionTypeObj = fetchedQuestionTypes.find(type => type.ID === question.QuestionType);
  const questionType = questionTypeObj?.Type?.toLowerCase() || 'multiple choice';
  return {
    questionId: question.QuestionID,
    text: question.QuestionText || '',
    options: Array.isArray(question.Options)
      ? question.Options.map(opt => ({
          value: opt.OptionText || '',
          isDefault: opt.IsDefault || false,
          optionId: opt.OptionID,
          weightage: opt.Weightage || '',
        }))
      : [],
    questionType,
    addCommentBox: question.QuestionComments || false,
    userResponse: question.Paragraph?.[0]?.ParagraphText || '',
    min: question.Scale?.MinValue ?? '',
    max: question.Scale?.MaxValue ?? '',
    minLabel: question.Scale?.[0]?.MinValueLabel || '',
    maxLabel: question.Scale?.[0]?.MaxValueLabel || '',
  };
};
const mapQuestions = (questions, questionTypes) => {
  return questions.map(q => formatQuestion(q, questionTypes));
};

const mapMeasures = (subsections, questionTypes) => {
  return subsections.map(measure => ({
    measureId: measure.SubSectionID,
    measureName: measure.SubSectionName || 'Untitled Measure',
    questions: Array.isArray(measure.Questions)
      ? mapQuestions(measure.Questions, questionTypes)
      : [],
  }));
};

const mapSections = (sections, questionTypes) => {
  return sections.map(section => ({
    sectionId: section.SectionID,
    title: section.SectionName || 'Untitled Section',
    description: section.SectionDescription || '',
    weightage: section.SectionWeightage || '',
    measures: Array.isArray(section.SubSections)
      ? mapMeasures(section.SubSections, questionTypes)
      : [],
  }));
};



  useEffect(() => {
    const fetchSurveyDetails = async () => {
      try {
        setLoading(true);
        const questionTypesData = await apiService.fetchData('questions_types');
        const fetchedQuestionTypes = Array.isArray(questionTypesData.results) ? questionTypesData.results : [];
        setQuestionTypes(fetchedQuestionTypes);
        const data = await apiService.fetchData(`surveys/${surveyId}`);
        const survey = data?.results?.[0] || {};
        const formattedSections = mapSections(survey.Sections || [], fetchedQuestionTypes);

        setSurveyData({
          name: survey.Name || 'N/A',
          sections: formattedSections,
        });
        setExpandedSections(formattedSections.reduce((acc, section) => ({
          ...acc,
          [section.sectionId]: true,
        }), {}));
        setLoading(false);
      } catch (err) {
        console.error('Error fetching survey details:', err);
        setError('Failed to load survey details.');
        setLoading(false);
      }
    };
    if (surveyId) {
      fetchSurveyDetails();
    }
  }, [surveyId]);

  const toggleSectionVisibility = (sectionId) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId],
    }));
  };

  const handleResponseChange = (questionId, value, type = 'response') => {
    setUserResponses(prev => ({
      ...prev,
      [questionId]: {
        ...prev[questionId],
        [type]: value,
      },
    }));
  };

  const renderQuestionInput = (question) => {
    const handleTextInputChange = (questionId) => (e) => {
  handleResponseChange(questionId, e.target.value);
};
const handleRadioChange = (e) => {
  handleResponseChange(question.questionId, e.target.value);
};

  const handleCheckboxChange = (e) => {
  const currentResponses = userResponses[question.questionId]?.response || [];
  const newResponses = e.target.checked
    ? [...currentResponses, e.target.value]
    : currentResponses.filter(val => val !== e.target.value);
  handleResponseChange(question.questionId, newResponses);
};

    const supportsOptions = ['multiple choice', 'checkboxes', 'dropdown'].includes(question.questionType);
    const renderCommentBox = () => (
      <div className="survey-form-form-group" style={{ marginTop: '10px' }}>
        <input
          type="text"
          placeholder="Enter comment..."
          className="survey-form-comment-input"
          style={{ width: '100%', padding: '8px', border: '1px solid #013E7D4D', borderRadius: '4px' }}
          value={userResponses[question.questionId]?.comment || ''}
          onChange={(e) => handleResponseChange(question.questionId, e.target.value, 'comment')}
        />
      </div>
    );
    const renderOptions = () => (
      <div className="survey-form-options-list" style={{ width: '100%' }}>
        {question.options && question.options.length > 0 ? (
          question.options.map((option, optionIndex) => (
            <div
              key={optionIndex}
              className={
                question.questionType === 'multiple choice'
                  ? 'survey-form-radio-group'
                  : question.questionType === 'checkboxes'
                    ? 'survey-form-checkbox-group'
                    : 'survey-form-dropdown-group'
              }
              style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}
            >
              {question.questionType === 'multiple choice' && (
                
                  <input
  type="radio"
  name={`question-${question.questionId}`}
  value={option.value}
  checked={userResponses[question.questionId]?.response === option.value}
  onChange={handleRadioChange}
  style={{ marginRight: '8px' }}
/>

                
              )}
              {question.questionType === 'checkboxes' && (
                
                  
                  <input
  type="checkbox"
  value={option.value}
  checked={userResponses[question.questionId]?.response?.includes(option.value) || false}
  onChange={handleCheckboxChange}
  style={{ marginRight: '8px' }}
/>

                
              )}
              {question.questionType === 'dropdown' && <span style={{ marginRight: '8px' }}>{optionIndex + 1}. </span>}
              <input
                type="text"
                value={option.value}
                readOnly
                className="survey-details-option-input"
                style={{ flex: 1, marginRight: '8px', width: '600px',gap:'5px' }}
              />
              <input
                type="text"
                value={option.weightage || ''} 
                readOnly
                className="survey-details-weightage-input"
                placeholder="Weight"
                style={{ width: '15px', padding: '8px', border: '1px solid #013E7D4D', borderRadius: '4px' }}
              />
            </div>
          ))
        ) : (
          <Typography>No options available.</Typography>
        )}
      </div>
    );
    switch (question.questionType) {
      case 'multiple choice':
      case 'checkboxes':
      case 'dropdown':
        return (
          <>
            <div className="survey-form-form-row survey-form-option-row">{renderOptions()}</div>
            {question.addCommentBox && renderCommentBox()}
          </>
        );
      case 'short answer':
        return (
          <>
            <div className="survey-form-form-group">
              
              <input
  type="text"
  value={userResponses[question.questionId]?.response || question.userResponse || ''}
  onChange={handleTextInputChange(question.questionId)}
  placeholder="Enter your response..."
  className="survey-form-option-input"
/>

            </div>
            {question.addCommentBox && renderCommentBox()}
          </>
        );
      case 'paragraph':
        return (
          <>
            <div className="survey-form-form-group">
              <textarea
                value={userResponses[question.questionId]?.response || question.userResponse || ''}
                onChange={(e) => handleResponseChange(question.questionId, e.target.value)}
                placeholder="Enter your response..."
                className="survey-form-paragraph-input"
                style={{ width: '400px',height:'60px' }}
              />
            </div>
            {question.addCommentBox && renderCommentBox()}
          </>
        );
      case 'linear scale':
        
        const minValue = question.min !== undefined && question.min !== '' ? Number(question.min) : 1;
const maxValue = question.max !== undefined && question.max !== '' ? Number(question.max) : 10;
        console.log(`Q${question.questionId} - min:`, question.min, 'max:', question.max);

        const range = Array.from({ length: maxValue - minValue + 1 }, (_, i) => minValue + i);
        const hasLabels = question.minLabel || question.maxLabel;
        return (
          <>
            <div className="survey-form-linear-scale-group">
              <div className="survey-form-linear-scale-range" style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                <div style={{ display: 'flex', gap: '15px', width:'100%',justifyContent:'space-around'}}>
                  {range.map((value) => (
                    <div key={value} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                      <input
                        type="radio"
                        name={`question-${question.questionId}`}
                        value={value}
                        checked={userResponses[question.questionId]?.response === value}
                        onChange={(e) => handleResponseChange(question.questionId, Number(e.target.value))}
                        style={{ marginRight: '5px' }}
                      />
                      <span>{value}</span>
                    </div>
                  ))}
                </div>
              </div>
              {hasLabels && (
                <div  style={{ display: 'flex', justifyContent: 'space-between',flexDirection:'row', marginTop: '30px',gap:'400px' }}>
                  <div className="survey-form-form-group">
                    {question.minLabel && (
                      <input
                        type="text"
                        value={question.minLabel}
                        readOnly
                        placeholder="No label"
                        style={{
                          
                          padding: '3px',
                          backgroundColor: '#F5F8FA',
                          width: '200px',
                          minHeight: '30px',
                        }}
                      />
                    )}
                  </div>
                  <div className="survey-form-form-group">
                    {question.maxLabel && (
                      <input
                        type="text"
                        value={question.maxLabel}
                        readOnly
                        placeholder="No label"
                        style={{
                          
                          padding: '3px',
                          backgroundColor: '#F5F8FA',
                          width: '200px',
                          minHeight: '30px',
                        }}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
            {question.addCommentBox && renderCommentBox()}
          </>
        );
      default:
        return <Typography color="error">Error: Unrecognized question type "{question.questionType}".</Typography>;
    }
  };

  if (!surveyId) return null;

  return (
    <Box sx={{p:3,maxHeight: '60vh', 
    overflowY: 'auto',marginBottom:'20px'}}>
      
      {loading && (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column', 
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  width: '100%',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                 
                  zIndex: 10, 
                }}
              >
                <div className="loading-dots">
                  <span></span>
                  <span></span>
                  <span></span>
                  
                  
                </div>
                <Typography
                  sx={{
                    marginTop: '12px',
                    color: '#013E7D', 
                    fontSize: '16px',
                    fontWeight: 500,
                  }}
                >
                  Loading survey data...
                </Typography>
              </Box>
            )}
      {error && <Typography color="error">{error}</Typography>}
      {surveyData && (
        <div className="survey-details-questions-tab">
          <h1 className='survey-title'>{surveyData.name}</h1>
          {surveyData.sections.map((section, idx) => (
            <div key={section.sectionId} className="add-survey-section-box">
              <div className="add-survey-section-header">
                <div onClick={() => toggleSectionVisibility(section.sectionId)} style={{ cursor: 'pointer' ,width:'100%'}}>
                  <div className="survey-details-section-count-wrapper">
                    <span className="survey-details-section-count">
                      Section {idx + 1} of {surveyData.sections.length}
                    </span>
                  </div>
                  <div className="survey-details-section-title">
                    <img
                      id={`toggle-arrow-${section.sectionId}`}
                      src={expandedSections[section.sectionId] ? downarrow : arrowicon}
                      alt="Toggle Arrow"
                      className="response-arrow-icon"
                    />
                    
                    <strong style={{ marginLeft: '10px' }}>
    {section.title}
    {section.weightage && (
      <span style={{ marginLeft: '8px', fontWeight: 'normal', color: '#666' }}>
        ({section.weightage}%)
      </span>
    )}
  </strong>
                  </div>
                </div>
              </div>
              {expandedSections[section.sectionId] && (
                <div>
                  <Typography id="default">{section.description}</Typography>
                  <div style={{ borderBottom: '1px solid #00000033', margin: '10px 0' }}></div>
                  <div className="add-survey-questions-list" id="default">
  {section.measures?.length > 0 ? (
    section.measures.map((measure, mIdx) => (
      <div key={measure.measureId || mIdx} className="survey-measure-block">
        <Typography
          variant="h6"
          style={{ marginTop: '10px', color: '#013E7D' }}
        >
          {measure.measureName}
        </Typography>

        {measure.questions?.length > 0 ? (
          measure.questions.map((q, qIdx) => (
            <div
              key={q.questionId}
              className="add-survey-question-box"
              id={`question-${q.questionId}`}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  width: '100%',
                }}
              >
                <span>{qIdx + 1}.</span>
                <Typography style={{ flex: 1 }}>{q.text}</Typography>
              </div>
              {renderQuestionInput(q)}
              <div
                style={{
                  borderBottom: '1px solid #00000033',
                  margin: '10px 0',
                }}
              ></div>
            </div>
          ))
        ) : (
          <Typography>No questions in this measure.</Typography>
        )}
      </div>
    ))
  ) : (
    <Typography>No measures in this section.</Typography>
  )}
</div>

                </div>
              )}
            </div>
          ))}
          {surveyData.sections.length === 0 && (
            <Typography>No sections available for this survey.</Typography>
          )}
        </div>
      )}
    </Box>
  );
};

ViewSurveyTemplate.propTypes = {
  surveyId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
};

export default ViewSurveyTemplate;